import getQueryFilterFormat from './GetQueryFilterFormat'

const getQuerySearchFormat = (columnType, searchValue) =>
  `{ ${columnType}:{contains:"${searchValue}"}}`
const getOrder = (activeSort, sortInverted) => {
  if (activeSort) {
    return ` order: {${activeSort}:${sortInverted ? 'DESC' : 'ASC'}} `
  }
  return ''
}
const getSkipTake = (pageLength, pageIndex) => `skip:${pageLength * pageIndex} take:${pageLength}`

const getDefaultFilters = (defaultFilters) => {
  if (defaultFilters) {
    const filterList = []
    defaultFilters.forEach(defaultFilter => {
      filterList.push(`${defaultFilter.propertyName}:{${defaultFilter.comparator}:${typeof defaultFilter.value === 'string'
        ? `"${defaultFilter.value}"`
        : defaultFilter.value
        }}`)
    });
    return `{${filterList.join('')}}`
  }
  return ''
}
const getFilter = (filters, defaultFilters, activeColumns, searchValue) => {
  const processedFilters = getFilters(filters)  
  const processedDefaultFilter = getDefaultFilters(defaultFilters)
  const searchFilter = getSearchFilter(activeColumns, searchValue)
  if (processedDefaultFilter || searchFilter || processedFilters[0]) {
    return ` where:{and:[${processedDefaultFilter},${searchFilter},${processedFilters}]}`
  }
  return "";
}
const getPageInfo = () => `pageInfo{hasNextPage hasPreviousPage}totalCount`

const getSearchFilter = (activeColumns, searchValue) => {
  const activeStringColumns = activeColumns.filter(
    (x) => x.dataType === 'String'
  )
  if (activeStringColumns && activeStringColumns[0] && searchValue) {
    return `{or:[${activeStringColumns.map((x) =>
      getQuerySearchFormat(x.propertyName, searchValue)
    )}]}`
  }
  return ''
}
const getFilters = (filters) => (filters ? filters.map((x) => getQueryFilterFormat(x)) : null)

const getType = (column) => {
  switch (column.dataType) {
    case 'OBJECT[]':    
    case 'LIST':
    case 'OBJECT': 
    const fields=column.fields.map(x=>getType(x)).join(' ')
    return `${column.propertyName}{${fields}}`
    //replace when displayName is added to objects
    
    default: return column.propertyName;
  }
}

const getItems = (activeColumns, mandatoryColumns) => {
  return `items{${mandatoryColumns
    .filter(x => !activeColumns
      .find(y => y.propertyName === x))
    .join(' ')} ${activeColumns
      .map(x => getType(x))
      .join(' ')}}`
}
const getHeader = ({
  pageLength,
  pageIndex,
  activeSort,
  sortInverted,
  filters,
  defaultFilters,
  searchValue,
  activeColumns
}) =>
  `(${getSkipTake(pageLength, pageIndex)}${getOrder(
    activeSort,
    sortInverted
  )}${getFilter(filters, defaultFilters, activeColumns, searchValue)})`
const getBody = (activeColumns, mandatoryColumns) => {
  return `${getPageInfo()} ${getItems(activeColumns, mandatoryColumns)}`
}
const createQuery = ({
  type,
  pageLength,
  pageIndex,
  activeSort,
  sortInverted,
  defaultFilters,
  activeColumns,
  searchValue,
  filters,
  columns,
  mandatoryColumns,
}) => {
  let usedColumns = [];
  for (let i = 0; i < columns.length; i++) {
    const column = columns[i];        
    for (let j = 0; j < activeColumns.length; j++) {
      const activeColumnName = activeColumns[j];
      if (column.propertyName === activeColumnName) {
        usedColumns.push(columns[i])
        continue;
      }

      if (activeColumnName.includes(' ')) {
        let splittedName = activeColumnName.split(' ');
        if ((column.propertyName === splittedName[0])) {

          const fields = [];
          const subSplit = splittedName[1].replace("{", "").replace("}", "").split(' ');
          for (let k = 0; k < subSplit.length; k++) {
            const fieldName = subSplit[k];
            for (let l = 0; l < column.fields.length; l++) {
              const field = column.fields[l];
              if(fieldName===field.propertyName){
                fields.push(field)
              }
            }
            usedColumns.push({propertyName:column.propertyName,dataType:"OBJECT",fields:fields})                        
          }
        } else {

          continue;
        }
      }
    }
  }

  
  let query = `query ${type}{${type}${getHeader({
    pageLength,
    pageIndex,
    activeSort,
    sortInverted,
    filters,
    defaultFilters,
    searchValue,
    activeColumns: usedColumns
  })}{${getBody(usedColumns, mandatoryColumns)}}}`

  console.log(query);
  return query
}

export default createQuery
